import { render, staticRenderFns } from "./PriceWorkflowSignoff.vue?vue&type=template&id=2db86050&"
import script from "./PriceWorkflowSignoff.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowSignoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports